import { ApiState } from "infrastructure/api";
import type { RootState } from "infrastructure/store";
import type { PspKycSetting } from "./types";

export const selectPspKycSettingsSlice = (state: RootState) =>
    state.pspKycSettings.settings.tableSlice;

export const selectPspKycSettings = (state: RootState): PspKycSetting[] =>
    selectPspKycSettingsSlice(state)?.data ?? [];

export const selectIsPspKycSettingsLoading = (state: RootState) =>
    state.pspKycSettings.settings.tableLoadingState === ApiState.Pending;
